import ManagementCommunity from './ManagementCommunity';

export default ManagementCommunity;
